module.exports = __webpack_public_path__ + "def55a283aa7194e1205f79a9238ea1c.svg";